export default class ProductUpdate {
	id: string;

	priceTypeForCalculation: string | null;

	packageSizeForCalculation: number | null;

	packageSizeForSingleUnit: number | null;

	dosageStrengthForCalculation: number | null;

	selected: boolean;

	constructor(
		id: string,
		priceTypeForCalculation: string | null,
		packageSizeForCalculation: number | null,
		packageSizeForSingleUnit: number | null,
		dosageStrengthForCalculation: number | null,
		selected: boolean
	) {
		this.id = id;
		this.priceTypeForCalculation = priceTypeForCalculation;
		this.packageSizeForCalculation = packageSizeForCalculation;
		this.packageSizeForSingleUnit = packageSizeForSingleUnit;
		this.dosageStrengthForCalculation = dosageStrengthForCalculation;
		this.selected = selected;
	}
}
